import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Banner } from '@lanl-web/lanl-components';
import { getImageUrl } from '../../utils';
import './BoxBanner.scss';

export const BoxBanner = ({ content, contentSide }) => {
  const category = content.category ?? '';
  const featuredImage = getImageUrl(content.image ?? '');
  const link = content.url ?? '#';
  const title = content.title ?? '';
  const subtitle = content.subtitle ?? '';
  const btnText = content.btnText;

  return (
    <Banner
      btnText={btnText}
      category={category}
      featuredImage={featuredImage}
      btnLink={link}
      title={title}
      subtitle={subtitle}
      contentSide={contentSide}
      className='box-banner'
      target='_self'
    />
  );
};

BoxBanner.defaultProps = {
  content: {
    btnText: 'Learn More',
  },
  contentSide: 'left',
};

BoxBanner.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    btnText: PropTypes.string,
    category: PropTypes.string,
    subtitle: PropTypes.string,
    url: PropTypes.string,
  }),
  contentSide: PropTypes.string,
};

export default BoxBanner;

export const fragBoxBanner = graphql`
  fragment boxBanner on DirectusData_rl_components {
    banners {
      banner {
        button_text
        description
        section
        title
        image {
          filename_disk
        }
        button_url {
          page {
            slug
            parent {
              slug
              parent {
                slug
                parent {
                  slug
                }
              }
            }
          }
          project {
            slug
          }
        }
      }
    }
  }
`;
